var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home-navbar" }, [
    _c(
      "div",
      {
        staticClass: "flex-horizontal",
        staticStyle: { height: "100%", "align-items": "center" }
      },
      [
        _c("home-tabs-management"),
        _vm._v(" "),
        _c("back-to-workspace-selection"),
        _vm._v(" "),
        _c("home-layout-selection"),
        _vm._v(" "),
        _c("fullscreen")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36f77f22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36f77f22","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/NavBar/NavBar.vue
// module id = null
// module chunks = 